export default __webpack_public_path__ + "static/media/Realme_Three.5ec98307.png";